// extracted by mini-css-extract-plugin
export default {"plSettingsHeader":"plSettingsHeader-KAF3l","firstRow":"firstRow-lufR3","secondRow":"secondRow-UFKjK"};